import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/neanderthal_website/frontend/node_modules/next/dist/client/app-dir/link.js");
